/** BE `benefitTags[].benefitType`. */
export const CT_UPGRADE_BENEFIT_TYPE = 'CT_UPGRADE'

export const ANCILLARY_DISCOUNT_CALLOUT_STYLE = {
    BACKGROUND: 'linear-gradient(90deg, rgba(236, 248, 244, 0) 0%, rgb(236, 248, 244) 63.4%)',
} as const

/** Pre-rendered by BE. FE prints as-is. */
export const getSmbVasCallout = (couponDetails?: { addOnDiscountCouponCallout?: string } | null) =>
    couponDetails?.addOnDiscountCouponCallout || ''
